import { createEntityAdapter } from '@reduxjs/toolkit'

import type { Conversation, Message } from '../model/types'

const conversations = createEntityAdapter<
	Conversation,
	Conversation['entity_id']
>({
	selectId: conversation => conversation.entity_id
	// sortComparer: sortNewFirst
})

const messages = createEntityAdapter<Message, Message['message_id']>({
	selectId: message => message.message_id
})

export { conversations, messages }
